import { render, staticRenderFns } from "./liveUrl.vue?vue&type=template&id=0c3ac62e&scoped=true&"
import script from "./liveUrl.vue?vue&type=script&lang=js&"
export * from "./liveUrl.vue?vue&type=script&lang=js&"
import style0 from "./liveUrl.vue?vue&type=style&index=0&id=0c3ac62e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3ac62e",
  null
  
)

export default component.exports